export default {
  name: 'choices',

  ui: {
    'choice[]': '[js-choices-choice]',
  },

  events: [
    {
      target: 'choice',
      on: 'click',
      handle (e) {
        e.preventDefault();
        this.ui.choice.forEach(el => {
          el.classList.remove('is-active');
        });
        const choice = e.currentTarget;
        choice.classList.add('is-active');
        choice.querySelector('input').checked = true;
        this.btSubmit.removeAttribute('disabled');

        if (choice.getAttribute('js-choices-choice') !== '') {
          const props = JSON.parse(choice.getAttribute('js-choices-choice'));
          const target = choice.closest('.slide-qualification-form').querySelector(props.target);
          const formTarget = choice.closest('.slide-qualification-form').querySelector(props.formTarget);
          if (props.action === 'enable') {
            target.classList.add('is-active');
            formTarget.setAttribute('required', true);
          } else {
            target.classList.remove('is-active');
            formTarget.removeAttribute('required');
            formTarget.value = '';
          }
        }
      },
    },
  ],

  componentDidMount () {
    this.btSubmit = this.el.closest('[js-choices-wrapper]').querySelector('[js-choices-submit]');
  },
};
